import { Price, Product } from '../types/Add-subscription.types';

interface AddonItemProps {
  product: Product;
  price: Price;
  quantity: number;
  isSelected: boolean;
  onToggle: () => void;
  getAdvantages: (product: Product, price: Price) => { name: string }[];
}

const AddonItem = ({
  product,
  price,
  quantity,
  isSelected,
  onToggle,
  getAdvantages,
}: AddonItemProps) => {
  const totalPrice =
    quantity < price.max_additional
      ? price.price * quantity
      : price.additional_price * quantity;
  const descriptionArray = getAdvantages(product, price);

  return (
    <div key={price.id} className="item__addon__container">
      <div className="item__addon__header">
        <div className="addon-item__checkbox">
          <label htmlFor={`addon-${price.id}`} className="item__addon__label">
            {product.title}
          </label>
          {`$ ${totalPrice.toFixed(2)}`}
        </div>
        <div className="addon-item__price">
          <input
            type="checkbox"
            id={`addon-${price.id}`}
            checked={isSelected}
            onChange={onToggle}
          />
        </div>
      </div>
      {descriptionArray &&
        descriptionArray.map((item, index) => (
          <p key={index} className="addon-item__description">
            {item.name}
          </p>
        ))}
    </div>
  );
};

export default AddonItem;
